export const numberWithCommas = (x) => {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0;
};

export const formatMoney = (value) => {
  const amount = Number(String(value ?? 0).replace(/,/g, ""));

  if (!Number.isFinite(amount)) return "0.00";

  return amount.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
